// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"nN-z","carouselContainer":"oN-z"};